import embeddedCalendlyTemplate from './embedded-calendly.tpl.html';
import './embedded-calendly.less';
import { asyncLoaderServiceModule } from '../../../../shared/app/services/async-loader-service/async-loader-service';

const CALENDLY_WIDGET = 'https://assets.calendly.com/assets/external/widget.js';
const CALENDLY_BASE = 'https://calendly.com/';

export const embeddedCalendlyComponentModule = angular
  .module('Q.components.embedded-calendly', [asyncLoaderServiceModule])

  .component('embeddedCalendly', {
    bindings: {
      calendlyLink: '@',
      calendlyPrefill: '<',
      calendlyUtm: '<',
      calendlyEvent: '@',
    },
    controller: 'EmbeddedCalendlyCtrl',
    template: embeddedCalendlyTemplate,
  })

  .controller(
    'EmbeddedCalendlyCtrl',
    function EmbeddedCalendlyCtrl(
      $element,
      $window,
      $log,
      asyncLoaderService,
      trackerService,
    ) {
      const ctrl = this;

      ctrl.$onInit = () => {
        trackerService.trackEvent(`${ctrl.calendlyEvent} Started`);

        const loading = $element.querySelector('.calendly-loading');
        const widgetNode = $element.querySelector('.calendly-widget')[0];
        asyncLoaderService
          .load(CALENDLY_WIDGET)
          .then(() => {
            if (!$window.Calendly)
              throw new Error('Unable to locate Calendly object');
            loading.remove();
            $window.Calendly.initInlineWidget({
              url: CALENDLY_BASE + ctrl.calendlyLink,
              parentElement: widgetNode,
              prefill: ctrl.calendlyPrefill,
              utm: ctrl.calendlyUtm,
            });
          })
          .catch((err) => {
            trackerService.trackEvent(`${ctrl.calendlyEvent} Error`);
            $log.error('Unable to load Calendly', err);
            $window.location = CALENDLY_BASE + ctrl.calendlyLink;
          });
      };

      const calendlyEventListener = (event) => {
        // Note: we can listen to other events, too:
        // calendly.profile_page_viewed: Profile page was viewed
        // calendly.event_type_viewed: Event type page was viewed
        // calendly.date_and_time_selected: Invitee selected date and time
        // calendly.event_scheduled: Invitee successfully booked a meeting
        if (event.data.event === 'calendly.event_type_viewed') {
          trackerService.trackEvent(
            `${ctrl.calendlyEvent} Meeting Type Selected`,
          );
        }
        if (event.data.event === 'calendly.date_and_time_selected') {
          trackerService.trackEvent(`${ctrl.calendlyEvent} Time Selected`);
        }
        if (event.data.event === 'calendly.event_scheduled') {
          trackerService.trackEvent(`${ctrl.calendlyEvent} Success`);
        }
      };

      $window.addEventListener('message', calendlyEventListener);
      ctrl.$onDestroy = () => {
        $window.removeEventListener('message', calendlyEventListener);
      };
    },
  );
